<template>
  <div id="app">
    <router-view v-if="showPage" />
    <div class="public-button-wrap">
      <el-button
        v-for="(item, i) in menus"
        :key="i"
        type="text"
        :class="{ active: active === i }"
        @click="targetHandle(item, i)"
      >
        <div :class="[item.className, 'icon_']"></div>
        <div>{{ item.label }}</div>
      </el-button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { wxCpLogin } from "@/api/index.js";

export default {
  computed: {
    login() {
      return this.$store.state.normal.login;
    }
  },
  data() {
    return {
      active: 0,
      showPage: false,
      menus: [
        {
          label: "首页",
          className: "el-icon-s-home",
          routeName: "Home"
        },
        {
          label: "我的",
          className: "el-icon-user-solid",
          routeName: "Mine"
        }
      ]
    };
  },
  created() {
    // localStorage.setItem(
    //   "Authorization",
    //   "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxIiwiZXhwIjoxNzM5Nzk4OTgzLCJ1c2VySWQiOjEsImlhdCI6MTczOTcxMjU4MywiYWNjb3VudCI6ImFkbWluIiwidXNlcktleSI6Inh4eHgifQ.-nRYSVudghRzWrNvxQCz_0RgvNM8drIINk-zxFvSZml1jJ975Bwf-0gqHa7NOV_mv6EvSDN8NQCSlJJ9c3vzLw"
    // );
    if (this.$route.query.token) {
      localStorage.setItem("Authorization", this.$route.query.token);
    }
    // 微信公众平台登陆code
    if (this.$route.query.code) {
      this.onWxCpLogin(this.$route.query.code);
    } else {
      this.showPage = true;
    }
  },
  watch: {
    login(val) {
      console.log(val);
    },
    "$route.name"(val) {
      if (val.startsWith("Mine")) {
        this.active = 1;
      } else {
        this.active = 0;
      }
    }
  },
  methods: {
    targetHandle(target, i) {
      this.active = i;
      this.$router.push({
        name: target.routeName
      });
    },
    onWxCpLogin(code) {
      wxCpLogin(code).then(res => {
        if (res) {
          localStorage.setItem("Authorization", res.token);
        }
        this.showPage = true;
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
#app
  font-family Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #2c3e50
  height 100%
  overflow auto
  position relative
  .public-button-wrap {
    height: 60px;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
    border-top: 1px solid #cccccc;
    display: flex;
    button {
      width: 50%;
      .icon_ {
        font-size: 25px;
        margin-bottom: 3px;
      }
      color: #666666;
      &.active {
        color: #57b837;
      }
    }
  }
</style>

<style lang="stylus">
// 修改所有支付宝支付按钮样式
// .el-button.alipay-btn {
//   font-size: 11px!important;
//   background-color: transparent!important; //更浅的背景颜色
//   color: #bdc1c9!important; //更浅的字体颜色
//   border-color: transparent!important; //边框颜色
// }
</style>
